import { camo } from './camo';
import { classic } from './classic';
import { modern } from './modern';
import { professional } from './professional';
import { patriotic } from './patriotic';
import { vintage } from './vintage';

export const hockey = {
  classic,
  vintage,
  modern,
  professional,
  patriotic,
  camo,
};
